import React from 'react';
import { Link } from 'react-router-dom';
import { AppButton } from '../../components/AppButton/AppButton';

/**
 * props:
 * - onNewAutomationClick
 */
function CreateBotButton({ onNewAutomationClick }) {
    return (
        <>
            <AppButton
                id="btnCreateBot"
                variant="primary"
                size="md"
                className="dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                </svg>
                Create bot
            </AppButton>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="btnCreateBot">
                <li><Link className="dropdown-item" to="/unified-setup">Algo bot</Link></li>
                <li><Link className="dropdown-item" to="/grid">Grid bot</Link></li>
                <li><Link className="dropdown-item" to="/scheduled">Scheduled bot</Link></li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                    <button
                        type="button"
                        id="linkRegular"
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#modalAutomation"
                        onClick={onNewAutomationClick}
                    >
                        Condition automation (advanced)
                    </button>
                </li>
            </ul>
        </>
    );
}

export default CreateBotButton;